import { api_urls_http, api_urls_https } from "../constants";

export let api_urls;
export let web_urls = window.location.host + '/';
export let kundli_urls = 'https://kundli2.astrosetalk.com/';

if (window.location.protocol === 'http:') {
    // api_urls = 'http://192.168.0.23:4019/';
    api_urls = api_urls_http;
} else if (window.location.protocol === 'https:') {
    api_urls = api_urls_https;
} else {
    console.log('Unknown protocol');
}